import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert } from "@devowl-wp/react-folder-tree";
import { ProFooter } from "./proFooter.js";
import { __ } from "../../utils/i18n.js";
import { request } from "../../utils/request.js";
import { rmlOpts } from "../../utils/rmlOpts.js";
function AppTreeAlerts() {
    const handleDismissImportTaxNotice = async ()=>{
        await request({
            location: {
                path: "/notice/import",
                method: "DELETE"
            }
        });
        window.location.reload();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            rmlOpts.others.isDevLicense && /*#__PURE__*/ _jsx(Alert, {
                message: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        __("Product license not for production use!"),
                        " (",
                        /*#__PURE__*/ _jsx("a", {
                            href: __("https://devowl.io/knowledge-base/license-installation-type/"),
                            rel: "noreferrer",
                            target: "_blank",
                            children: __("Learn more")
                        }),
                        ")"
                    ]
                }),
                type: "warning",
                style: {
                    marginBottom: "10px"
                }
            }),
            rmlOpts.others.showTaxImportNotice && /*#__PURE__*/ _jsx(Alert, {
                message: /*#__PURE__*/ _jsxs("span", {
                    children: [
                        __("It looks like you have already used another plugin for folders in the media library."),
                        " ",
                        /*#__PURE__*/ _jsx("a", {
                            href: rmlOpts.others.taxImportNoticeLink,
                            children: __("Start importing")
                        }),
                        " \xb7",
                        " ",
                        /*#__PURE__*/ _jsx("a", {
                            href: "#",
                            onClick: handleDismissImportTaxNotice,
                            children: __("Dismiss")
                        })
                    ]
                }),
                type: "info",
                style: {
                    marginBottom: "10px"
                }
            }),
            !rmlOpts.others.isPro && rmlOpts.others.showProHints && rmlOpts.others.showLiteNotice && /*#__PURE__*/ _jsx(ProFooter, {
                dismissible: true,
                feature: "sidebar"
            })
        ]
    });
}
export { AppTreeAlerts };
